
import { SYM_PROP_LINKING } from "../enum/Symbol";
import useMarkParentLinking from "./utils/useMarkParentLinking";
import { useMarkRootProp } from "./chain/store/useStoreRoot";


const exportAllowPropsKey = (props) => {
    const keys = Object.keys(props);
    keys.push(SYM_PROP_LINKING);
    return keys
}

/**
 * 
 * @param {Object} props 
 * @param {Object} parentProps 
 */
const usePropsForwarder = (props, parentProps) => {
    const selfPropKey = new Set(exportAllowPropsKey(props));
    const forwarder = new Proxy(props, {
        set(o, k, v) {
            if (!selfPropKey.has(k)) {
                return Reflect.set(parentProps, k, v, parentProps);
            }
            return Reflect.set(...arguments)
        },
        get(o, k) {
            if (!selfPropKey.has(k)) {
                return Reflect.get(parentProps, k, parentProps);
            }
            return Reflect.get(...arguments)
        }
    })
    // linkRootToProps(forwarder,parentProps)

    return forwarder;
}

export default usePropsForwarder